import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  deleteModal: {
    backgroundColor: theme.palette.primary.dark,
  },
}));
